<div class="card-occasion-options-container">
  <button
    class="card-occasion-options-btn"
    mat-icon-button
    [matMenuTriggerFor]="optionSelect"
  >
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #optionSelect="matMenu">
    <app-smart-link
      customClass="mat-menu-item"
      [route]="editRoute"
      (onSmartClick)="onSelectString(options[0])"
    >
      <span>{{ options[0] }}</span>
    </app-smart-link>

    <app-smart-link
      customClass="mat-menu-item"
      [route]="detailsRoute"
      (onSmartClick)="onSelectString(options[1])"
    >
      <span>{{ options[1] }}</span>
    </app-smart-link>

    <ng-container *ngFor="let item of options; index as i">
      <button mat-menu-item *ngIf="i > 1" (click)="onSelectString(item)">
        <span>{{ item }}</span>
      </button>
    </ng-container>
  </mat-menu>
</div>
